export default "__VITE_ASSET__DvHDY1jj__"